"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecialDesign = void 0;
const Tags_1 = require("../Tags");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Size_1 = require("../render/Size");
class SpecialDesign extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.SPECIAL_DESIGN,
            tags: [Tags_1.Tags.SCIENCE],
            cost: 4,
            metadata: {
                cardNumber: '206',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.plate('Global requirements', Size_1.Size.LARGE).colon().text('± 2');
                }),
                description: 'The next card you play this generation is +2 or -2 steps in global requirements, your choice.',
            },
        });
    }
    getRequirementBonus(player) {
        if (player.lastCardPlayed !== undefined && player.lastCardPlayed.name === this.name) {
            return 2;
        }
        return 0;
    }
    play() {
        return undefined;
    }
}
exports.SpecialDesign = SpecialDesign;
//# sourceMappingURL=SpecialDesign.js.map